import _ from '@/utils/lodash-optimized'
import PropTypes from 'prop-types'

import Statuses from '../../../../lib/Codes/ActionStatuses'
import { Modal, Checkbox } from '../../../shared/NarusMaterial'

export const ActionStatusModal = ({
  issue,
  actions,
  onIdAdd,
  defaultStatus
}) => {
  const newStatusLabel = _.toLower(
    Statuses.all.find(s => {
      if (s.value === defaultStatus) {
        return s
      }
    }).label
  )

  return (
    <Modal
      title={`Do you wish to complete any of these actions? Unchecked actions will be changed to ${newStatusLabel}.`}
      actions={actions}
    >
      <div className='row'>
        {issue.actions.map((a, index) => {
          const changeToCompleted = !(a.status === 'completed')
          return (
            <div
              key={index}
              className='col-xs-12'
              style={{ paddingTop: '15px' }}
            >
              <Checkbox
                value={a.status === 'completed'}
                onChange={() => {
                  onIdAdd(a.id, changeToCompleted, defaultStatus)
                }}
                label={a.description}
              />
            </div>
          )
        })}
      </div>
    </Modal>
  )
}

ActionStatusModal.propTypes = {
  issue: PropTypes.any.isRequired,
  actions: PropTypes.any.isRequired
}
